import { Injectable } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Document, DropBoxDocument } from '@eemo/api-client';

@Injectable({ providedIn: 'root' })
export class FileHelper {
  constructor(private sanitizer: DomSanitizer) {}

  imageApiToHtml(file: Blob, type: 'img' | 'style' = 'img'): SafeUrl | null {
    if (file) {
      const objectURL = URL.createObjectURL(file);
      if (type === 'img') {
        return this.sanitizer.bypassSecurityTrustUrl(objectURL);
      } else {
        return this.sanitizer.bypassSecurityTrustStyle(objectURL);
      }
    }

    return null;
  }
}

export function isDocument(doc: Document | DropBoxDocument): doc is Document {
  return typeof doc === 'object' && !('senderMail' in doc);
}

export function isDropBoxDocument(doc: Document | DropBoxDocument): doc is DropBoxDocument {
  return typeof doc === 'object' && 'senderMail' in doc;
}
